// extracted by mini-css-extract-plugin
export default {"NewHealthCheckDialog":"NewHealthCheckDialog_NewHealthCheckDialog__K9s6V"};